// @ts-nocheck
import * as React from "react";
import {useState} from "react";
import Button from "@mui/material/Button";
import Modal from "@mui/material/Modal";
import {Box} from "@mui/material";
import JSONInput from 'react-json-editor-ajrm';
import locale from "react-json-editor-ajrm/locale/en";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faTimes} from "@fortawesome/pro-light-svg-icons";
import styled from "styled-components/macro";

const style = {
  position: 'absolute' as 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 'calc(min(80vw, 800px))',
  bgcolor: 'background.paper',
  border: '1px solid #FF74E9',
  borderRadius: '20px',
  boxShadow: 24,
};

// mixing presets:
const mixingPreset1 = {
  "eq": [
    {
      "_type": "high_pass",
      "cutoff_hz": 130
    },
    {
      "_type": "peak",
      "gain_db": -3,
      "q_factor": 1,
      "cutoff_hz": 380
    }
  ],
  "reverb": {
    "send_db": -12.9,
    "dry_level": 1,
    "room_size": 0.7
  },
  "normalize": {
    "headroom": 2
  },
  "compressor": {
    "ratio": 2.3,
    "attack_ms": 11,
    "release_ms": 34,
    "threshold_db": -23.5
  },
  "adjust_volume": {
    "gain_change_db": -2
  }
}

const mixingPreset2 = {
  "eq": [
    {
      "_type": "high_pass",
      "cutoff_hz": 230
    },
    {
      "_type": "peak",
      "gain_db": -3,
      "q_factor": 1,
      "cutoff_hz": 380
    },
    {
      "_type": "high_shelf",
      "gain_db": -6,
      "q_factor": 1,
      "cutoff_hz": 6000
    }
  ],
  "reverb": {
    "send_db": -8.9,
    "dry_level": 1,
    "room_size": 0.5
  },
  "compressor": {
    "ratio": 2.3,
    "attack_ms": 71,
    "release_ms": 140,
    "threshold_db": -17.5
  },
  "adjust_volume": {
    "gain_change_db": -8
  }
}

const mixingPresetInstrumental = {
  "adjust_volume": {
    "gain_change_db": -3
  }
}

export function LayerTrackMixingArgsInput(props) {
    const {id, value, onTrackMixingArgsChange} = props;
    const [isOpen, setIsOpen] = useState(false);
    const [jsonObjValue, setJsonObjValue] = useState(null)
    const [errorValue, setErrorValue] = useState(null)




    const handleClick = (event: React.MouseEvent<HTMLElement>) => {
        setIsOpen(true)
    };

    const handleClose = () => {
        setIsOpen(false);
    }

    const handleChange = (v) => {
      // setJsonInputValue(v)
      if (v.jsObject) setJsonObjValue(v.jsObject)
      if (v.error) setErrorValue(v.error)
    }

    const handleClickPreset = (jsonObject) => {
      setJsonObjValue(jsonObject)
    }

    const handleSave = () => {
        onTrackMixingArgsChange(jsonObjValue)
        handleClose()
    }

    return (
        <div>
            <Button aria-describedby={id} type="button" variant="outlined" onClick={handleClick}>
                MIX
            </Button>
          {isOpen && (
            <Modal open={isOpen} onClose={() => setIsOpen(false)}>
                <Box sx={style}>
                  <ModalContent>
                    <ModalHeader>
                      <h2>
                        Edit Track Mix
                      </h2>
                      <FontAwesomeIcon icon={faTimes} onClick={handleClose} size={"xs"} />
                    </ModalHeader>
                    <MixingPresetList>
                      <Button aria-describedby={id} type="button" variant="outlined" onClick={() => handleClickPreset(mixingPreset1)}>
                        PRESET 1 (LV)
                      </Button>
                      <Button aria-describedby={id} type="button" variant="outlined" onClick={() => handleClickPreset(mixingPreset2)}>
                        PRESET 2 (BV)
                      </Button>
                      <Button aria-describedby={id} type="button" variant="outlined" onClick={() => handleClickPreset(mixingPresetInstrumental)}>
                        PRESET 2 (Instrumental)
                      </Button>

                    </MixingPresetList>
                    <JSONInput
                        id={"a_unique_id" + id}
                        placeholder={jsonObjValue}
                        error={errorValue}
                        locale={locale}
                        height='550px'
                        onChange={(v) => handleChange(v)}
                    />
                    <Button aria-describedby={id} type="button" variant="outlined" onClick={handleSave}>
                        SAVE
                    </Button>
                  </ModalContent>
                </Box>
            </Modal>
          )}
        </div>
    )
}

const ModalHeader = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  
  padding-top: 32px;
  padding-right: 16px;
  padding-left: 16px;
  
`;

const ModalContent = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: stretch;
  position: relative;
  padding-right: 32px;
  padding-left: 32px;
  padding-bottom: 32px;

  border-radius: 20px;
  overflow: visible;
  min-height: 400px;
`;

const MixingPresetList = styled.div`
`;